//region :: Imports ::
import {IMsalContext} from '@azure/msal-react';
import AccessTokenProvider from '../Toolkit/AccessTokenProvider';

//endregion;

/** */
class WorkerHubAccessTokenProvider extends AccessTokenProvider {

    /** */
    public constructor(msalContext: IMsalContext) {
        super(msalContext, ['api://f2a6f1f4-26ed-4547-b0dd-eece0c77a5d7/user_impersonation']);

    }

}

export default WorkerHubAccessTokenProvider;
